import type {
  PointerGestureMoveDetail,
  PointerGesturePressDetail,
  PointerGestureReleaseDetail,
} from "../../input/PointerGestureInterpreter";
import type { DragSessionPort } from "./DragSessionPort";
import type { DesignerTransformer } from "./DesignerTransformer";

/** Product drag lifecycle adapter; movement constraints remain owned by DesignerTransformer. */
export class ProductMoveSession
  implements
    DragSessionPort<
      void,
      PointerGestureMoveDetail,
      PointerGestureReleaseDetail
    >
{
  readonly commitClick = true;

  constructor(private readonly _transformer: DesignerTransformer) {}

  begin(_input?: void): void {
    // Session is opened by DesignerTransformer.beginProductMove before construction.
  }

  move(event: PointerGestureMoveDetail): void {
    this.update(event);
  }

  update(event: PointerGestureMoveDetail): void {
    this._transformer.updateProductMove(event);
  }

  commit(event: PointerGestureReleaseDetail): void {
    void event;
    this._transformer.commitProductMove();
  }

  cancel(): void {
    this._transformer.cancelProductMove();
  }

  dispose(): void {
    this._transformer.clearActiveProductMoveSession(this);
  }
}
